"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Label["default"];
  }
});
var _Label = _interopRequireDefault(require("./Label"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }